// extracted by mini-css-extract-plugin
module.exports = {"swipe":"swipe--1lAql","editable":"editable--1Vjae","inner":"inner--3FHwl","underlay":"underlay--2Os5p","swiped":"swiped--Nixva"};